module.exports = __webpack_public_path__ + "static/history-stage-jun-2019-9e1d643beee55ea2e1eec4dd801526fc.jpg";